"use strict";

exports.__esModule = true;
exports.default = void 0;

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var _default = setStatic;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/setStatic.js
// module id = 191
// module chunks = 104158497352714 128747004913641